import { SvgIcon } from '@mui/material'

import { CUSTOM_ICON_ELEMENTS, ICON_ELEMENTS } from '@constants'

export interface IAcIcon {
  icon: string
}

export const AcIcon = ({ icon }: IAcIcon) => {
  const Icon = ICON_ELEMENTS[icon as keyof typeof ICON_ELEMENTS]
  if (Icon) return <Icon />
  if (!Icon) {
    const CustomIcon =
      CUSTOM_ICON_ELEMENTS[icon as keyof typeof CUSTOM_ICON_ELEMENTS]
    if (CustomIcon) {
      return (
        <SvgIcon>
          <CustomIcon />
        </SvgIcon>
      )
    }
  }
  return null
}
